import React, { Fragment } from 'react'

import { 
  FormControl,
  MenuItem,
} from '@material-ui/core'
import InputLabel from '../../../../base/InputLabel'
import { withStyles } from '@material-ui/core/styles'
import styles from '../../ItemFormStyles'
import SelectWithSavedNote from '../../SelectWithSavedNote'

class ItemFormEbayShippingType extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      value: props.defaultValue || undefined,
    }
  }

  onChange = function(e) {
    this.setState({ value: e.target.value })
  }

  render() {   
    const { classes } = this.props; 
    return (
      <Fragment>
        <InputLabel>Shipping Type</InputLabel>
        <FormControl 
          className={classes.valueControl}
          required
          fullWidth
        >
          <SelectWithSavedNote
            name="shippingType"
            value={this.state.value || ''}
            required={true}
            onChange={this.onChange.bind(this)}
          >
            <MenuItem value={'Flat'}>Flat</MenuItem>
            <MenuItem value={'Calculated'}>Calculated</MenuItem>
          </SelectWithSavedNote>
        </FormControl>
      </Fragment>
    )
  }
}

export default withStyles(styles)(ItemFormEbayShippingType)